<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="w-100" style="max-width: 450px;" *ngIf="!emailSent; else success">

    <!-- Logo -->
    <div class="text-center logo-container mb-4">
      <a [routerLink]="'/'" class="navbar-logo">
        <img src="assets/logo_dt.png" alt="Dental Tour Logo" class="img-fluid logo-image">
      </a>
    </div>


    <div class="card shadow-sm login-card">
      <div class="card-body p-4">

        <div class="d-flex align-items-center mb-3">
          <a [routerLink]="['/login']" class="text-decoration-none text-primary d-flex align-items-center back-link">
            <i class="ti ti-arrow-left me-2"></i>
            <span>{{ 'Back to Login' | translate }}</span>
          </a>
        </div>

        <h5 class="card-title text-center mb-1 fw-bold">{{ 'Forgot Password' | translate}}</h5>
        <p class="text-center text-muted mb-4 small">
          {{ 'Enter your email address and we will send you a link to reset your password' | translate }}
        </p>

        <form [formGroup]="emailForm" (ngSubmit)="sendEmail()" novalidate>

          <div class="mb-3">
            <label for="email" class="form-label fw-semibold">{{ 'Email' | translate }}</label>
            <div class="position-relative">
              <i class="ti ti-mail input-icon"></i>
              <input type="email" class="form-control ps-5" id="email" formControlName="email"
                placeholder="{{ 'Enter your email' | translate }}"
                [class.is-invalid]="emailForm.get('email')?.invalid && emailForm.get('email')?.touched"
                [class.is-valid]="emailForm.get('email')?.valid && emailForm.get('email')?.touched" required />
            </div>
          </div>

          <button type="submit"
            class="btn btn-primary w-100 d-flex justify-content-center align-items-center py-2 submit-btn"
            [disabled]="emailForm.invalid || isLoading">

            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
              aria-hidden="true"></span>
            <span class="fw-semibold">{{ isLoading ? ('Sending...' | translate ): ('Send Reset Link' | translate)
              }}</span>
            <i *ngIf="!isLoading" class="ti ti-send ms-2"></i>

          </button>

        </form>
      </div>
    </div>

  </div>

  <ng-template #success>
    <div class="card login-card py-4 px-3">
      <div class="d-flex flex-column align-items-center justify-content-center text-center">
        <div class="success-icon-wrapper mb-3">
          <i class="ti ti-circle-check text-success"></i>
        </div>
        <h3 class="mb-3 fw-bold">{{ 'Link sent successfully' | translate }}</h3>
        <p class="text-muted mb-2" [innerHTML]="'We sent a link to your email.' | translate"></p>
        <p class="text-muted mb-4 small"
          [innerHTML]="'Please click it to continue resetting your password.' | translate"></p>
        <button class="btn btn-primary px-4 py-2 submit-btn" (click)="toHome()">
          <span class="fw-semibold">{{ 'Return to Home' | translate }}</span>
          <i class="ti ti-home ms-2"></i>
        </button>
      </div>
    </div>
  </ng-template>
</div>